import { render, staticRenderFns } from "./MobileStickyCart.vue?vue&type=template&id=24ccf94a&"
import script from "./MobileStickyCart.vue?vue&type=script&lang=js&"
export * from "./MobileStickyCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ccf94a')) {
      api.createRecord('24ccf94a', component.options)
    } else {
      api.reload('24ccf94a', component.options)
    }
    module.hot.accept("./MobileStickyCart.vue?vue&type=template&id=24ccf94a&", function () {
      api.rerender('24ccf94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/MobileStickyCart.vue"
export default component.exports